export function getValidationStatus(file) {
  if (!file) return "notRegistered";
  if (file.validado === 2) return "validated";
  if (file.validado === 1) return "notValidated";
  return "notRegistered";
}

export function processTreeData(tree) {
  const projectStats = {};

  function traverseNode(node, currentProject, currentFolder) {
    if (node.level === 2 && node.type === "folder") {
      currentProject = node.name;
      if (!projectStats[currentProject]) {
        projectStats[currentProject] = {
          projectName: currentProject,
          validated: 0,
          notValidated: 0,
          notRegistered: 0,
          total: 0,
          folders: {},
        };
      }
    }
    if (node.level === 3 && node.type === "folder" && currentProject) {
      currentFolder = node.name;
      if (!projectStats[currentProject].folders[currentFolder]) {
        projectStats[currentProject].folders[currentFolder] = {
          validated: 0,
          notValidated: 0,
          notRegistered: 0,
          total: 0,
        };
      }
    }
    if (node.type === "file" && currentProject) {
      let status;

      if (node.jsonData) {
        status = getValidationStatus(node.jsonData);
      } else {
        status = "notRegistered";
      }
      projectStats[currentProject][status]++;
      projectStats[currentProject].total++;
      if (currentFolder && projectStats[currentProject].folders[currentFolder]) {
        projectStats[currentProject].folders[currentFolder][status]++;
        projectStats[currentProject].folders[currentFolder].total++;
      }
    }
    if (node.children) {
      node.children.forEach((child) => traverseNode(child, currentProject, currentFolder));
    }
  }
  traverseNode(tree);
  return projectStats;
}



export function getGlobalStats(projectStats) {
  return Object.values(projectStats).reduce(
    (acc, project) => ({
      validated: acc.validated + project.validated,
      notValidated: acc.notValidated + project.notValidated,
      notRegistered: acc.notRegistered + project.notRegistered,
      total: acc.total + project.total,
    }),
    { validated: 0, notValidated: 0, notRegistered: 0, total: 0 }
  );
}

export function getAllFiles(tree) {
  const files = [];

  function traverseNode(node) {
    if (node.type === "file" && node.jsonData) {
      files.push(node.jsonData);
    }
    if (node.children) {
      node.children.forEach((child) => traverseNode(child));
    }
  }

  traverseNode(tree);
  return files;
}

export function getFilesByProjectAndFolder(tree, projectName, folderName) {
  const files = [];

  function traverseNode(node, currentProject, currentFolder) {
    if (node.level === 2 && node.type === "folder") {
      currentProject = node.name;
    }
    if (node.level === 3 && node.type === "folder" && currentProject) {
      currentFolder = node.name;
    }
    if (node.type === "file" && currentProject === projectName && currentFolder === folderName) {
      files.push(node.jsonData || {
        nameResource: node.name,
        fullPath: node.path,
        state: 0,
        validado: 0
      });
    }
    if (node.children) {
      node.children.forEach((child) => traverseNode(child, currentProject, currentFolder));
    }
  }

  traverseNode(tree);
  return files;
}
